import type { SensoreDTO } from '../../dto/plc/sensore-dto'

const calculateSensorName = (sensor: SensoreDTO): string => {
    if (sensor.gruppo && sensor.posizione && sensor.numero) {
        if(sensor.numero === "-1"){
            return `${sensor.gruppo} ${sensor.posizione}`
        }

        return `${sensor.gruppo} ${sensor.numero} ${sensor.posizione}`
    }

    return sensor.aliasId ?? ''
}

export { calculateSensorName }
